import { api } from '../lib/api';

export interface QueenBatchListItem {
  id: number;
  batchCode: string;
  graftedAt: string;
  queenCount: number;
  takeCount: number | null;
  notes: string | null;
  motherHiveSiteId: number;
  motherHiveName: string | null;
  motherHiveNo: number | null;
  motherApiaryName: string | null;
  assignmentCount: number;
}

export interface QueenBatchAssignment {
  id: number;
  targetType: 'HIVE' | 'MATING_NUC';
  targetHiveSiteId: number | null;
  targetMatingNucId: number | null;
  assignedAt: string;
  notes: string | null;
  targetHiveName: string | null;
  targetHiveNo: number | null;
  targetHiveApiaryName: string | null;
  targetMatingNucNo: number | null;
  targetMatingNucLabel: string | null;
  targetLocationName: string | null;
}

export interface QueenBatchDetail {
  id: number;
  batchCode: string;
  graftedAt: string;
  queenCount: number;
  takeCount: number | null;
  notes: string | null;
  motherHiveSiteId: number;
  motherHiveName: string | null;
  motherHiveNo: number | null;
  motherApiaryName: string | null;
}

export interface QueenMatingNuc {
  id: number;
  nucNo: number;
  label: string | null;
  locationSiteId: number | null;
  notes: string | null;
  currentQueenBatchId: number | null;
  currentQueenAssignedAt: string | null;
  currentQueenBatchCode: string | null;
  locationName: string | null;
  isActive: number;
}

export interface QueenMetaHive {
  siteId: number;
  name: string;
  hiveNo: number | null;
  apiaryName: string | null;
}

export interface QueenMetaSite {
  id: number;
  name: string;
  parentName: string | null;
  siteTypeLabel: string | null;
}

export interface QueenMetaResponse {
  hives: QueenMetaHive[];
  sites: QueenMetaSite[];
}

export const queensApi = {
  meta: () => api.get<QueenMetaResponse>('/queens/meta'),
  batches: {
    list: () => api.get<{ items: QueenBatchListItem[] }>('/queens/batches'),
    get: (id: number) => api.get<{ batch: QueenBatchDetail; assignments: QueenBatchAssignment[] }>(`/queens/batches/${id}`),
    create: (payload: { graftedAt: string; motherHiveSiteId: number; queenCount: number; notes?: string }) =>
      api.post<{ id: number; batchCode: string }>('/queens/batches', payload),
    update: (id: number, payload: { graftedAt: string; motherHiveSiteId: number; queenCount: number; takeCount?: number | null; notes?: string }) =>
      api.patch<{ ok: boolean }>(`/queens/batches/${id}`, payload),
  },
  matingNucs: {
    list: () => api.get<{ items: QueenMatingNuc[] }>('/queens/mating-nucs'),
    create: (payload: { nucNo: number; label?: string; locationSiteId: number; notes?: string }) =>
      api.post<{ id: number }>('/queens/mating-nucs', payload),
    update: (id: number, payload: { nucNo: number; label?: string; locationSiteId: number; notes?: string; isActive: boolean }) =>
      api.patch<{ ok: boolean }>(`/queens/mating-nucs/${id}`, payload),
  },
  assignments: {
    create: (payload: {
      queenBatchId: number;
      targetType: 'HIVE' | 'MATING_NUC';
      targetHiveSiteId?: number;
      targetMatingNucId?: number;
      assignedAt: string;
      notes?: string;
    }) => api.post<{ id: number }>('/queens/assignments', payload),
  },
};
